module.exports = {
    btn_track:"查询",
    TrackingNumber:"跟踪号",
    OrderCode:"订单号",
    NewestTrack:"最新轨迹",
    Status:"状态",
    All:"全部",
    NotFound:"查询不到",
    Receivedin:"已上网",
    InTransit:"运输中",
    PickUp:"到达代取",
    Delivered:"已签收",
    Undelivered:"派送失败",
    Alert:"异常",
    Returned:"已退件",
    QfishOrderTracking:"快飞鱼物流追踪",
    Channel:"渠道",
    PleaseEnterNumbers:"请输入单号",
    Max_Query_Count_Tips:"最多查询80个订单",
    Footer_Copyright_Countent:"深圳市快飞鱼供应链有限公司版权所有"
  };